import React from "react";
import _ from "lodash";
import { inject } from "mobx-react";
import { PropTypes } from "prop-types";
import { NotifyOutsideClick } from "core/components";
import { defaultTemplate } from "core/hoc";
import { RouterLink } from "mobx-state-router";
import logo from "themes/assets/img/logo-header-w.svg";
import { version } from "../../../../package.json";
const APP_VERSION = `v${version}`;

const SecondaryMenu = inject((i) => ({
    items: i.rootStore.menuStore.secondaryMenu,
    menuStore: i.rootStore.menuStore,
}))(defaultTemplate(SecondaryItems));

const TerniaryMenu = inject((i) => ({
    items: i.rootStore.menuStore.terniaryMenu,
    menuStore: i.rootStore.menuStore,
}))(defaultTemplate(TerniaryItems));

function MenuTemplate({ menuStore, t, routerStore }) {
    return (
        <NotifyOutsideClick action={() => menuStore.closeMenu()}>
            <div
                className={
                    menuStore.isCollapsed
                        ? "layout__aside is-collapsed"
                        : "layout__aside"
                }
            >
                <React.Fragment>
                    {renderPrimary(menuStore.menu, menuStore, t, routerStore)}
                </React.Fragment>
            </div>
        </NotifyOutsideClick>
    );
}

function renderPrimary(menu, menuStore, translate, routerStore) {
    return (
        <div className="menu--flex">
            <div className="logo__wrap">
                <img
                    className="logo"
                    src={logo}
                    alt="logo"
                    onClick={() =>
                        routerStore.goTo("master.app.main.dashboard")
                    }
                />
            </div>

            <div
                className={
                    menuStore.isOpen ? "nav--primary is-open" : "nav--primary"
                }
            >
                <div
                    onClick={() => menuStore.toggleMenuOpen()}
                    className="nav--primary__close"
                >
                    <i className="u-icon u-icon--xmed u-icon--close--nav"></i>
                </div>

                {_.map(menu, (item) => {
                    let className = "nav--primary__item";
                    if (
                        menuStore.selectedPath &&
                        menuStore.selectedPath.length > 0
                    ) {
                        if (menuItemActive(item, menuStore.selectedPath)) {
                            className += " selected";
                        }
                    }
                    if (menuItemActive(item, menuStore.activePath)) {
                        className += " active";
                    }
                    let hasActiveChild = false;
                    if (item.hasChildren) {
                        item.subMenu.forEach((item) => {
                            if (menuItemActive(item, menuStore.activePath)) {
                                hasActiveChild = true;
                                if (
                                    menuStore.activePath[0].title ===
                                        (menuStore.selectedPath.length > 0 &&
                                            menuStore.selectedPath[0].title) ||
                                    menuStore.selectedPath.length === 0
                                ) {
                                    className += " selected";
                                }
                            }
                        });
                    }
                    const title = translate(item.title);
                    if (
                        (!hasActiveChild &&
                            item.hasChildren &&
                            className.includes("selected")) ||
                        (hasActiveChild &&
                            menuStore.selectedPath.length === 0) ||
                        (className.includes("selected") &&
                            menuStore.activePath[0].title ===
                                (menuStore.selectedPath[0] &&
                                    menuStore.selectedPath[0].title))
                    ) {
                        return (
                            <div key={title}>
                                <div
                                    className={className}
                                    aria-label={title}
                                    onClick={(event) =>
                                        menuStore.selectMenuItem(event, item)
                                    }
                                >
                                    <span className="nav--primary__flex">
                                        <span className="nav--primary__holder">
                                            <span
                                                title={title}
                                                className={
                                                    "nav--primary__icon  u-icon--" +
                                                    item.icon
                                                }
                                            />
                                            <span title={title} className="nav--primary__label">
                                                {title}
                                            </span>
                                        
                                        {item.hasChildren ? (
                                            <span className="nav--primary__caret">
                                                <span className="u-icon u-icon--med u-icon--arrow-down--positive"></span>
                                            </span>
                                        ) : null}
                                        </span>
                                    </span>
                                </div>
                                <SecondaryMenu />
                            </div>
                        );
                    } else if (item.hasChildren) {
                        return (
                            <div
                                key={title}
                                aria-label={title}
                                className={className}
                                label={title}
                                onClick={(event) =>
                                    menuStore.selectMenuItem(event, item)
                                }
                            >
                                <div className="nav--primary__wrap">

                                <span className="nav--primary__flex">
                                <span className="nav--primary__holder">
                                    <span
                                        title={title}
                                        className={
                                            "nav--primary__icon  u-icon--" +
                                            item.icon
                                        }
                                    />

                                    <span title={title} className="nav__text">
                                        {title}
                                    </span>
                                    <span className="nav--primary__caret">
                                        <span className="u-icon u-icon--med u-icon--arrow-down--positive"></span>
                                    </span>
                                    </span>
                                    </span>
                                </div>
                            </div>
                        );
                    } else {
                        return (
                            <RouterLink key={title} routeName={item.getRoute()}>
                                <div
                                    aria-label={title}
                                    className={className}
                                    label={title}
                                    onClick={(event) =>
                                        menuStore.selectMenuItem(event, item)
                                    }
                                >
                                    <span className="nav--primary__flex">
                                        <span className="nav--primary__holder">
                                            <span
                                                title={title}
                                                className={
                                                    "nav--primary__icon  u-icon--" +
                                                    item.icon
                                                }
                                            />

                                            <span title={title} className="nav__text">
                                                {title}
                                            </span>
                                        </span>
                                    </span>
                                    {/* {item.hasChildren ? (
                                        <span className="nav--primary__caret">
                                            <span className="u-icon u-icon--tny u-icon--arrow-down--positive"></span>
                                        </span>
                                    ) : null} */}
                                </div>
                            </RouterLink>
                        );
                    }
                })}
                
            </div>
            <div
            className={
                menuStore.isOpen ? "nav--primary__collapse is-open" : "nav--primary__collapse"
            }
                    title="Toggle Menu"
                    onClick={() => menuStore.toggleCollapse()}
                >
                    <i className="u-icon u-icon--med u-icon--circle-right"></i>
                    <div className="type--color--negative">
                        {APP_VERSION}
                    </div>
                </div>
        </div>
    );
}

function menuItemActive(item, activePath = []) {
    if (item.path.length > activePath.length) return false;

    for (let i = 0; i < item.path.length; i++) {
        if (item.path[i] !== activePath[i]) {
            return false;
        }
    }

    return true;
}

function SecondaryItems({ items, menuStore, t }) {
    if (!items || items.length === 0) return null;
    return (
        <div
            className={
                "nav--secondary" +
                (menuStore.secondaryMenuVisible ? " active" : "")
            }
        >
            <ul>
                {items.map((item) => {
                    let className = "nav--secondary__item";
                    if (menuItemActive(item, menuStore.activePath)) {
                        className += " active";
                    }
                    if (menuItemActive(item, menuStore.selectedPath)) {
                        className += " selected";
                    }
                    const title = t(item.title);
                    if (className.includes("selected")) {
                        return (
                            <ul key={title}>
                                <li
                                    className={className}
                                    title={title}
                                    onClick={(event) =>
                                        menuStore.selectMenuItem(event, item)
                                    }
                                >
                                    <span className="nav--secondary__holder">{title}</span>
                                    {item.hasChildren ? (
                                        <span className="u-push">
                                            <span className="u-icon u-icon--tny u-icon--arrow-right"></span>
                                        </span>
                                    ) : null}
                                </li>
                                <TerniaryMenu />
                            </ul>
                        );
                    } else if (item.hasChildren) {
                        return (
                            <li
                                key={title}
                                title={title}
                                className={className}
                                onClick={(event) =>
                                    menuStore.selectMenuItem(event, item)
                                }
                            >
                                <span>{title}</span>
                                <span className="u-push">
                                    <span className="u-icon u-icon--tny u-icon--arrow-right"></span>
                                </span>
                            </li>
                        );
                    } else {
                        return (
                            <RouterLink key={title} routeName={item.getRoute()}>
                                <li
                                    title={title}
                                    className={className}
                                    onClick={(event) =>
                                        menuStore.selectMenuItem(event, item)
                                    }
                                >
                                    <span className="nav--secondary__holder">{title}</span>
                                    {item.hasChildren ? (
                                        <span className="u-push">
                                            <span className="u-icon u-icon--tny u-icon--arrow-right"></span>
                                        </span>
                                    ) : null}
                                </li>
                            </RouterLink>
                        );
                    }
                })}
            </ul>
        </div>
    );
}
function TerniaryItems({ items, menuStore, t }) {
    if (!items || items.length === 0) return null;
    return (
        <div
            className={
                "nav--tertiary layout__aside--secondary" +
                (menuStore.terniaryMenuVisible ? " active" : "")
            }
        >
            <ul>
                <li
                    className="nav--tertiary__back"
                    onClick={() =>
                        menuStore.setSelectedPath(items[0].parent.parent.path)
                    }
                >
                    <i className="u-icon u-icon--xmed u-icon--back"></i>
                </li>
                {items.map((item) => {
                    let className = "nav--tertiary__item";
                    if (menuItemActive(item, menuStore.activePath)) {
                        className += " active";
                    }
                    if (menuItemActive(item, menuStore.selectedPath)) {
                        className += " selected";
                    }

                    const title = t(item.title);
                    return (
                        <RouterLink key={title} routeName={item.getRoute()}>
                            <li
                                title={title}
                                className={className}
                                onClick={(event) =>
                                    menuStore.selectMenuItem(event, item)
                                }
                            >
                                {title}
                                {/* {item.hasChildren ? (
                                    <span className="u-push">
                                        <span className="u-icon u-icon--tny u-icon--arrow-right"></span>
                                    </span>
                                ) : null} */}
                            </li>
                        </RouterLink>
                    );
                })}
            </ul>
        </div>
    );
}

TerniaryItems.propTypes = {
    items: PropTypes.array,
    menuStore: PropTypes.object,
    t: PropTypes.func,
};
SecondaryItems.propTypes = {
    items: PropTypes.array,
    menuStore: PropTypes.object,
    t: PropTypes.func,
};

MenuTemplate.propTypes = {
    routerStore: PropTypes.object,
    menuStore: PropTypes.object,
    t: PropTypes.func,
};

export default defaultTemplate(MenuTemplate);
